// Station Board layout geometry — shared by the renderer (and mirrored by the
// admin designer). A board screen is a 24-column x 20-row grid mapped onto a
// fixed 16:9 stage, letterboxed inside the physical panel. Authoring at 16:9 in
// the designer therefore yields a pixel-identical layout on any TV resolution.
export const BOARD_COLS = 24;
export const BOARD_ROWS = 20;
export const BOARD_ASPECT = 16 / 9;

// Compute the centered 16:9 stage for a given viewport, plus cell sizes.
export function computeStage(viewportW, viewportH) {
  let width = viewportW;
  let height = width / BOARD_ASPECT;
  if (height > viewportH) {
    height = viewportH;
    width = height * BOARD_ASPECT;
  }
  return {
    width,
    height,
    left: (viewportW - width) / 2,
    top: (viewportH - height) / 2,
    colW: width / BOARD_COLS,
    rowH: height / BOARD_ROWS,
  };
}

// Pixel rect for a widget given its grid {x,y,w,h} and a computed stage.
export function widgetRect(widget, stage) {
  return {
    left: Math.round((widget.x || 0) * stage.colW),
    top: Math.round((widget.y || 0) * stage.rowH),
    width: Math.round((widget.w || 1) * stage.colW),
    height: Math.round((widget.h || 1) * stage.rowH),
  };
}

// Visible, ordered screens for rotation.
export function activeScreens(boardConfig) {
  return (boardConfig?.screens || []).filter((s) => s && (s.widgets || []).length >= 0);
}

// The Legacy template's widget: the original station board, which lays itself
// out on the whole display. A screen containing it is shown as the legacy
// board rather than as a grid.
export const LEGACY_BOARD_WIDGET = "legacyBoard";

export function isLegacyScreen(screen) {
  return (screen?.widgets || []).some((w) => w && w.type === LEGACY_BOARD_WIDGET);
}

// Storm Center widgets. A screen showing any of them gets the command-center
// type: its header and clocks switch to it too (unless set to "standard").
export const STORM_WIDGETS = ["stormMap", "stormCells", "stormReports", "nwsAlerts"];

export function isCommandScreen(screen) {
  return (screen?.widgets || []).some((w) => w && STORM_WIDGETS.includes(w.type));
}

// The class a header or clock widget adds for its `font` setting: "command"
// and "standard" force a face; anything else follows the screen.
export function fontClass(font) {
  return font === "command" ? " sb-font-command" : font === "standard" ? " sb-font-standard" : "";
}
